module.exports = __webpack_public_path__ + "img/logo-5defebrero.0105732e.png";